import * as actionTypes from "./actionTypes";
import api from "./api";
import { sendHttpCommandAndWaitForEvent, sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import { camelizeKeys } from "humps";
import { LANGUAGE_CHANGED } from "actions/actionTypes/index";
import * as eventTypes from "./eventTypes";

export function loadGlobalParams() {
  return async (dispatch, getState) => {
    let params = getState().params;
    if (params.loaded || params.loading) return;

    try {
      dispatch({ type: actionTypes.LOAD_GLOBAL_PARAMS_STARTED });
      params = await dispatch(sendHttpRequest(api.loadGlobalParams()));
        const result = {
          ...params.dynamicProperties,
          ...params
        };
        delete result.dynamicProperties;
        const camelizedJson = camelizeKeys(result);

        dispatch({ type: actionTypes.LOAD_GLOBAL_PARAMS_SUCCESS, payload: camelizedJson });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function resetCurrentOffer() {
  return async dispatch => {
    dispatch({ type: LANGUAGE_CHANGED });
  };
}

export const saveBehaviorParams = (name, value) => {
  return async dispatch => {
    dispatch({ type: actionTypes.SAVE_GLOBAL_PARAMS_STARTED });
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(api.saveGlobalParams(name, value), null, [eventTypes.GLOBAL_PARAMS_SAVED])
      );
      if (event.ok) {
        dispatch({ type: actionTypes.SAVE_GLOBAL_PARAMS_SUCCESS, payload: event.eventBody });
        return event;
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
};
